export default __webpack_public_path__ + "static/media/icons-slip-48-px.01f74970.svg";